// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailSearchForm__container--RftIL","mainSearchFields":"DetailSearchForm__mainSearchFields--VZ6zq","employmentStatuses":"DetailSearchForm__employmentStatuses--3Qo4d"};